import { required, sameAs, email as emailValidator } from 'vuelidate/lib/validators'; //eslint-disable-line
import { mapActions, mapState } from 'vuex';
import SocialBtn from 'Uikit/SocialBtn';
import { IconGoogleLogin, IconArrowMax, IconGoogle, IconPlus } from 'Icons';
import loginModalTabs from 'src/models/LoginModalTabs';
import validateFormMixin from 'src/mixins/validateForm';
import SuccessModal from './SuccessModal';


export default {
  mixins: [validateFormMixin],
  data: () => ({
    googleOauthLink: null,
    requestInProgress: false,
    showSuccessPopUp: false,
    sendGoogleOauthRequest: false,
    showResetPopUp: false,
    registerSuccess: false,
    iconPlusHoverState: false,
    serverFieldErrors: {
      login: {},
      register: {},
      forgot: {},
    },
    login: {
      email: '',
      password: '',
      rememberMe: false,
    },
    register: {
      email: '',
      password: '',
      confirmPassword: '',
      acceptTermsOfUse: false,
    },
    forgot: {
      email: '',
    },
  }),
  validations: {
    login: {
      email: {
        emailValidator,
        required,
        serverValidity() {
          return !(this.serverFieldErrors && this.serverFieldErrors.login.email);
        },
      },
      password: {
        required,
        serverValidity() {
          return !(this.serverFieldErrors && this.serverFieldErrors.login.password);
        },
      },
    },
    register: {
      email: {
        emailValidator,
        required,
        serverValidity() {
          return !(this.serverFieldErrors && this.serverFieldErrors.register.email);
        },
      },
      password: {
        required,
        serverValidity() {
          return !(this.serverFieldErrors && this.serverFieldErrors.register.password);
        },
      },
      confirmPassword: {
        sameAs: sameAs('password'),
        serverValidity() {
          return !(this.serverFieldErrors && this.serverFieldErrors.register.confirmPassword);
        },
      },
    },
    forgot: {
      email: {
        emailValidator,
        required,
        serverValidity() {
          return !(this.serverFieldErrors && this.serverFieldErrors.forgot.email);
        },
      },
    },
  },
  components: {
    SocialBtn,
    IconGoogleLogin,
    IconArrowMax,
    SuccessModal,
    IconGoogle,
    IconPlus,
  },
  created() {
    this.$apiService.getGoogleOauthLink().then((link) => {
      this.googleOauthLink = link;
    });
  },
  methods: {
    ...mapActions('userData', [
      'checkUserAuthSession',
    ]),
    ...mapActions('settings', [
      'toggleLoginModal',
    ]),
    clickOnGoogleBtn() {
      this.sendGoogleOauthRequest = true;
      this.iconPlusHoverState = false;
      window.location.href = this.googleOauthLink;
    },
    goTo(url) {
      window.open(url, '_self');
    },
    signIn() {
      this.requestInProgress = true;
      const {
        email,
        password,
        rememberMe,
      } = this.login;
      this.$apiService.signIn(email, password, rememberMe).then(() => {
        this.checkUserAuthSession();
        this.toggleLoginModal({ val: false });
        this.onSuccess();
      }).catch(({ fieldErrors }) => {
        if (fieldErrors) {
          this.serverFieldErrors.login = fieldErrors;
        }
      }).finally(() => {
        this.requestInProgress = false;
      });
    },
    signUp() {
      this.requestInProgress = true;
      const {
        email,
        password,
        confirmPassword,
      } = this.register;
      this.$apiService.signUp(email, password, confirmPassword).then(() => {
        this.registerSuccess = true;
        this.onSuccess();
      }).catch(({ fieldErrors }) => {
        if (fieldErrors) {
          this.serverFieldErrors.register = fieldErrors;
        }
      }).finally(() => {
        this.requestInProgress = false;
      });
    },
    updateForgotPassword() {
      this.requestInProgress = true;
      const {
        email,
      } = this.forgot;
      this.$apiService.forgotPassword(email).then(() => {
        this.registerSuccess = true;
        this.showResetPopUp = true;
      }).catch(({ fieldErrors }) => {
        if (fieldErrors) {
          this.serverFieldErrors.forgot = fieldErrors;
        }
      }).finally(() => {
        this.requestInProgress = false;
      });
    },
    tryToSendLoginForm() {
      this.validateForm('login', this.signIn.bind(this));
    },
    tryToSendRegisterForm() {
      this.validateForm('register', this.signUp.bind(this));
    },
    tryToSendForgotPasswordForm() {
      this.validateForm('forgot', this.updateForgotPassword.bind(this));
    },
    onSuccess() {
      this.showSuccessPopUp = true;
      if (this.$route.meta.redirectOnLogin) {
        this.$router.replace('/');
      }
    },
  },
  computed: {
    ...mapState('settings', [
      'loginModalActiveTab',
    ]),
    loginTabIsActive() {
      return this.loginModalActiveTab === loginModalTabs.login;
    },
    forgotPasswordIsActive() {
      return this.loginModalActiveTab === loginModalTabs.forgot;
    },
    submitIsDisabled() {
      return this.requestInProgress || !this.register.acceptTermsOfUse;
    },
    disabledGoogleBtn() {
      return !this.googleOauthLink || this.sendGoogleOauthRequest;
    },
    selectFirstTab() {
      return this.loginTabIsActive || this.forgotPasswordIsActive;
    },
    registerTabIsActive() {
      return this.loginModalActiveTab === loginModalTabs.register;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/loginTools/loginModalLogicMixin.js